import { Section, SectionTitle, Reveal } from "@/components/Section";
import { useContent } from "@/i18n";
import { Shape3D } from "@/components/Objects3D";

export const Education = () => {
  const { c, ui } = useContent();
  return (
    <Section id="education" num="03" chapter={ui.education.chapter}>
      <Shape3D shape="book" blue size={58} className="absolute right-[6%] top-20 hidden md:block" mouse />
      <SectionTitle className="max-w-3xl">
        {ui.education.titleA} <span className="italic text-cobalt">{ui.education.titleB}</span> {ui.education.titleC}
      </SectionTitle>

      <div className="mt-16 relative">
        <span className="hidden md:block absolute left-[8.5rem] top-0 bottom-0 w-px bg-line" aria-hidden="true" />
        {c.education.map((edu, i) => (
          <Reveal key={edu.degree} delay={0.05 * i}>
            <article className="group relative grid md:grid-cols-12 gap-6 md:gap-10 py-10 md:py-12 items-start" data-testid={`education-item-${i}`}>
              <div className="md:col-span-2 md:text-right">
                <span className={`inline-block rounded-full px-4 py-1.5 text-xs tracking-[0.18em] uppercase font-bold ${i % 2 === 0 ? "bg-powder text-choco" : "bg-beige text-choco"} ${i % 2 === 0 ? "-rotate-2" : "rotate-2"}`}>
                  {edu.period}
                </span>
              </div>
              <span className={`hidden md:block absolute left-[8.5rem] top-14 -translate-x-1/2 h-3.5 w-3.5 rounded-full border-2 ${i === 0 ? "bg-cobalt border-cobalt" : "bg-cream border-cobalt"}`} aria-hidden="true" />
              <div className="md:col-span-10 md:pl-10 border-b border-line pb-10 last:border-b-0">
                <h3 className="font-serif text-2xl md:text-4xl tracking-tight leading-tight group-hover:text-cobalt transition-colors duration-400">
                  {edu.degree}
                </h3>
                <p className="mt-2 text-sm tracking-[0.12em] uppercase font-bold text-cocoa">{edu.institution}</p>
                <p className="mt-5 max-w-2xl text-base leading-relaxed text-cocoa">{edu.description}</p>
                <div className="mt-5 flex flex-wrap gap-2">
                  {edu.tags.map((tag, ti) => (
                    <span key={tag} className={`rounded-full border px-3 py-1 text-xs tracking-wide ${ti % 3 === 1 ? "border-cobalt/50 text-cobalt" : "border-line text-cocoa"}`}>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          </Reveal>
        ))}
      </div>
    </Section>
  );
};
